import { useChatStore } from '@store/chatStore'
import { ChatPopout } from './ChatPopout'

export function ChatPopoutManager() {
  const popouts = useChatStore((state) => state.popouts)

  if (popouts.length === 0) return null

  return (
    <>
      {popouts.map((conversationId, index) => (
        <ChatPopout
          key={conversationId}
          conversationId={conversationId}
          index={index}
        />
      ))}
    </>
  )
}
